import { Injectable } from '@angular/core';
import { HomeserveParameters } from '../../shared/models/homeserve-parameters';

@Injectable({
	providedIn: 'root'
})
export class UrlParamsService {
	constructor() {}

	readonly nifParamKey: string = 'nif';
	readonly policyParamKey: string = 'policy';
	readonly dataParamkey: string = 'data';
	readonly langParamkey: string = 'lang';
	readonly utm_sourceParamkey: string = 'utm_source';
	readonly utm_mediumParamkey: string = 'utm_medium';
	readonly utm_campaignParamkey: string = 'utm_campaign';
	//ej: &utm_source=ltcnow&utm_medium=referral&utm_campaign=trescapas


	private decodeParams(params: string): HomeserveParameters {
		let nif: string = '';
		let policy: string = '';
		let data: string = '';
		let lang: string = '';
		let utm_source: string = '';
		let utm_medium: string = '';
		let utm_campaign: string = '';
		params
			.substring(1)
			.split('&')
			.map((p) => {
				if (p.startsWith(this.dataParamkey) && p.split('=').length === 2) {
					data = p.split('=')[1];
				}
				if (p.startsWith(this.nifParamKey) && p.split('=').length === 2) {
					nif = p.split('=')[1];
				}
				if (p.startsWith(this.policyParamKey) && p.split('=').length === 2) {
					policy = p.split('=')[1];
				}
				if (p.startsWith(this.langParamkey) && p.split('=').length === 2) {
					lang = p.split('=')[1];
				}
				if (p.startsWith(this.utm_sourceParamkey) && p.split('=').length === 2) {
					utm_source = p.split('=')[1];
				}
				if (p.startsWith(this.utm_mediumParamkey) && p.split('=').length === 2) {
					utm_medium = p.split('=')[1];
				}
				if (p.startsWith(this.utm_campaignParamkey) && p.split('=').length === 2) {
					utm_campaign = p.split('=')[1];
				}
			});
		return {
			nif: nif,
			policy: policy,
			data: data,
			lang: lang,
			utm_source: utm_source,
			utm_medium: utm_medium,
			utm_campaign: utm_source
		};
	}

	getDecodedParams(): HomeserveParameters {
		const params = window.location.search;
		return this.decodeParams(params);
	}

	setUrlParams(data: any){
		const url = new URL(window.location.href);
		const params = new URLSearchParams(url.search);
		const queryString = Object.entries(data)
		.map(([key, value]) => {
			if (value && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
				if (!params.get(key)){
					return key === 'data'
						? `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
						: `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
				}
			}
			return '';
		})
		.filter(item => item !== '')
		.join('');
		window.history.replaceState({}, '', url.search !== '' ? `${url.href}` : `${url}?${queryString}`);
	}
}
